import * as React from 'react';

import { Route } from 'react-router';

import { GeolocationModal } from 'components/geolocation-modal';
import { Routes } from 'components/routes';
import { relativeRoutes } from 'utils/routing';

export const GeolocationRoutes: React.FC = () => {
  return (
    <Routes>
      <Route path={relativeRoutes.locationService} element={<GeolocationModal />} />
    </Routes>
  );
};
